import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { MessageCircle } from "lucide-react";
import { BRAND } from "../mock/mock";

export default function Layout() {
  return (
    <div className="grain relative bg-viimii overflow-x-hidden min-h-screen">
      <Navbar />
      <Outlet />
      <Footer />
      <a
        href={`https://wa.me/${BRAND.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full grid place-items-center shadow-2xl hover:scale-110 transition-transform"
        style={{ background: "#25D366" }}
        aria-label="WhatsApp"
      >
        <MessageCircle size={26} className="text-white fill-white" />
      </a>
    </div>
  );
}
